/**
 * Maximum number of characters accepted by the BOM "Additional Info" field.
 * Shared by the BOM add/edit modal and the Product BOM inline grid, and mirrored
 * by the techpack PDF template (pdf-html-template/modules/bom-pdf.ejs) which
 * truncates at the same limit.
 */
export const ADDITIONAL_INFO_MAX_LENGTH = 5000;

export const commonPath = (index, keyName, compIndex) => {
  return {
    COMMON_PATH: `[${index}][${keyName}]`,
    COMPOSITION_PATH: `[${index}].composition.[${compIndex}].[${keyName}]`,
  };
};
export const colourWayPath = (parentIndex, colourIndex, index, keyName) => {
  return {
    COLOUR_WAY_PATH: `[${parentIndex}].colourWayRefsData[${colourIndex}].colourRefsDataAsPerSuppliers[${index}][${keyName}]`,
    COLOUR_WAY_REF_PATH: `[${parentIndex}].colourWayRefsData[${colourIndex}].colourRefsDataAsPerSuppliers[${index}][${keyName}]`,
    COLOUR_WAY_PATH_COLOURDATA: `[${parentIndex}].colourWayRefsData[${colourIndex}][${keyName}]`,
  };
};
